/* Rows, never cards (DESIGN_SYSTEM §3, fail list 1). Hairline separators. */
.list > li {
  border-top: 1px solid var(--line);
}

.list > li:last-child {
  border-bottom: 1px solid var(--line);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--s3);
  width: 100%;
  min-height: 64px;
  padding: var(--s3) 0;
  background: transparent;
  border: 0;
  color: var(--ink);
  text-align: left;
}

a.row:active,
button.row:active:not(:disabled) {
  background: var(--panel2);
}

.row:disabled {
  opacity: 0.45;
  cursor: default;
}

.split {
  display: flex;
  align-items: center;
  gap: var(--s3);
}

.split > .row {
  flex: 1 1 auto;
  min-width: 0;
}

.text {
  flex: 1 1 auto;
  min-width: 0;
}

.title {
  display: block;
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.titleLarge {
  display: block;
  font-size: 1.1875rem;
  line-height: 1.2;
  font-weight: 800;
  font-stretch: 105%;
}

.meta {
  display: block;
  margin-top: 2px;
  color: var(--ink2);
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 500;
  font-stretch: 90%;
}

.trailing {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--s2);
  color: var(--ink2);
}

.accent {
  color: var(--slate);
}
